export default __webpack_public_path__ + "static/media/logo.1082a7f7.png";